export default {
    required:        'Položka je povinná',
    decimal:         'Je povoleno pouze číslo',
    numeric:         'Položka musí být celé číslo',
    maxLength:       'Položka může obsahovat maximálně %p znaků',
    minLength:       'Položka může obsahovat minimálně %p znaků',
    domainValidator: 'Doména není ve správném tvaru. Např: www.mojedomena.cz, mujweb.cz',
}

/**
 * @param {Object} error
 * @return {String}
 */
export function errorParameter(error) {
    let parameter = null;
    const {type} = error;
    switch (type) {
        case 'maxLength':
            parameter = error.max;
            break;
        case 'minLength':
            parameter = error.min;
            break;
    }

    return parameter;
}
